// Persisted chat-widget integration selection.
// All five values are required; chatType is optional and guides the runtime.
export const chatWidgetConfig = {
  chatWidgetId: "6adb765f6c0798678bd8db47",
  locationId: "5FMGxd2SbzRDVO0B4g5P",
  coreUrl: "https://widgets.leadconnectorhq.com/chat-widget-core/core.esm.js",
  marketplaceUrl: "https://services.leadconnectorhq.com",
  source: "ai-studio-native",
  chatType: "emailChat" as const,
};
